export enum NivelLog {
    Error = 0,
    Debug = 1
}